import Router from "./router/Router"; // 오타 수정: Routor -> Router
import { useState, useEffect } from 'react';
import './css/app.css';

function App() {
  const [isDarkMode] = useState(() => {
    // 1. 초기 상태를 결정할 때 localStorage를 먼저 확인
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    // 2. 저장된 값이 없으면 시스템 설정을 확인
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    // 클래스 적용
    // if (isDarkMode) {
      document.body.classList.add('dark');
    //   localStorage.setItem('theme', 'dark');
    // } else {
    //   document.body.classList.remove('dark');
    //   localStorage.setItem('theme', 'light');
    // }
  }, [isDarkMode]);

//   const toggleDarkMode = () => {
//     setIsDarkMode(!isDarkMode);
//   };

  return (
    <div className="App">
      <header>
        {/* <h1>현재 모드: {isDarkMode ? "다크" : "라이트"}</h1> */}
        {/* <button onClick={toggleDarkMode}>
          {isDarkMode ? "라이트 모드로 변경" : "다크 모드로 변경"}
        </button> */}
      </header>
      <Router />
    </div>
  );
}

export default App;
